const content = {
    doordash_order_history: {
        en: {
            summary_html: "<p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below, and then you're ready to hit record and scroll through your order history.</p>",
            summary_no_video_html: "<p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit record and scroll through your order history.</p>",
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Open the <b>DoorDash</b> app and login before you start screen recording.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>In the app, tap on <b>Orders</b>.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '3',
                description_html: '<p>Scroll to the end of your order history before you stop recording.</p>'
              }
            ],
        }
    }
};

export const doordashDataTypes = {
    'doordash_order_history': {
        data_type: 'doordash_order_history',
        data_type_description: 'Doordash Order History',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/doordash-order-history/logo.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.doordash_order_history,
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.doordash_order_history,
        }
      },
}